import sample_1 from './sample1.jpeg';

export const dynamicImageImpressions = {
    sample_1,
};
